/**
 * React component for rendering a carousel with testimonial items.
 * @param {Object} props - The properties passed to the component.
 * @param {Object} props.data - Data object containing information for the carousel.
 * @param {Object} props.data.testimonialCarouselTexts - Testimonial data object containing text for carousel items.
 * @returns {JSX.Element} - The rendered React component for the testimonial carousel.
 */

import React, { useEffect, useState } from "react";
import commonstyles from "../../../common/commonstyles.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "../carouselSection/Carousel.module.scss";
import { Navigation } from "swiper/modules";
import styles from "./Carousel.module.scss";
import { EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import QuotesImages from "../SVG/carouselImages/QuotesImage";
import FiveStarsImage from "../SVG/carouselImages/FiveStarsImage";
import QuotesImageMobile from "../SVG/carouselImages/QuotesImageMobile";
import FiveStarsImageMobile from "../SVG/carouselImages/FiveStarImageMobile";
import CaroPrevArrow from "../SVG/CarouselArrows/CaroPrevArrow";
import CaroNextArrow from "../SVG/CarouselArrows/CaroNextArrow";
import CaroPrevMobile from "../SVG/CarouselArrows/CaroPrevMobile";
import CaroNextMobile from "../SVG/CarouselArrows/CaroNextMobile";

// TODO(ROSHAN): ANCHOR
const Carousel = ({ data }) => {
  const CAROUSEL_ITEMS = Object.entries(data?.testimonialCarouselTexts || {});

  let starCount = 0;
  let starColors = ["#0F32BC", "#006759"];

  const getStar = () => {

    const countToUse = starCount;
    starCount++;
    if ( starCount >= starColors.length) {
      starCount = 0;
    }

    return (<><div className="lg:pb-[64px] pb-[31px] m-auto hidden lg:block">
      <FiveStarsImage color={`${starColors[countToUse]}`} />
    </div>
    <div className="lg:pb-[64px] pb-[31px] m-auto block lg:hidden">
      <FiveStarsImageMobile color={`${starColors[countToUse]}`} />
    </div></>);
  };

  let quoteCount = 0;
  let quoteColors = ["#FB6945", "#692729", "#9EACFD", "#FB6945"];

  const getQuotes = () => {

    const countToUse = starCount;
    quoteCount++;
    if ( quoteCount >= quoteColors.length) {
      quoteCount = 0;
    }
    return (<>
      <div className="lg:pb-[64px] pb-[31px] m-auto hidden lg:block">
        <QuotesImages color={`${quoteColors[countToUse]}`} />
      </div>
      <div className="lg:pb-[64px] pb-[31px] m-auto block lg:hidden">
        <QuotesImageMobile color={`${quoteColors[countToUse]}`} />
      </div>
    </>);
  };

  return (
    <div className="homePageSwiper">
      <Swiper
        navigation={{
          prevEl: ".custom-swiper-button-prev", // Class selector for the previous button
          nextEl: ".custom-swiper-button-next", // Class selector for the next button
        }}
        modules={[EffectFade, Navigation]}
        effect="fade"
        className="mySwiper"
        loop={true}
      >
        {CAROUSEL_ITEMS.map(([key, value]) => (
          <SwiperSlide key={key}>
            <div className="flex flex-col">
              {value.type === 'customer_quote' ? getStar() : getQuotes()}
              <h2
                className={`lg:max-w-[720px] xl:max-w-[922px] m-auto lg:pb-[65px] pb-[30px]`}
              >
                <q>{value.text}</q>
              </h2>
              <div className="lg:pb-[64px] pb-[31px] m-auto">
                <div
                  className="testimonial-logo-wrap"
                  dangerouslySetInnerHTML={{ __html: value.logo }}
                ></div>
                {value.location || value.author ? (
                  <div className="flex flex-col lg:gap-[14px] gap-[9px] mt-[9px]">
                    <span className={` ${commonstyles.tmt_medium_18}`}>
                      {value.author}
                    </span>
                    <span
                      className={` ${commonstyles.tmt_medium_18} opacity-50`}
                    >
                      {value.location}
                    </span>
                  </div>
                ) : null}
              </div>
            </div>
          </SwiperSlide>
        ))}
        <div className="custom-swiper-button-prev cursor-pointer absolute z-10 left-0 top-[30%] hidden lg:block">
          <CaroPrevArrow />
        </div>
        <div className="custom-swiper-button-next cursor-pointer absolute z-10 right-0 top-[30%] hidden lg:block">
          <CaroNextArrow />
        </div>
        <div className="flex justify-center mt-[40px]">
          <div className="custom-swiper-button-prev cursor-pointer mr-[70px] absolute z-10  bottom-0 block lg:hidden">
            <CaroPrevMobile width={48} height={48} />
          </div>
          <div className="custom-swiper-button-next cursor-pointer ml-[70px] absolute z-10  bottom-0 block lg:hidden">
            <CaroNextMobile height={48} width={48} />
          </div>
        </div>
      </Swiper>
    </div>
  );
};

export default Carousel;
